import React from 'react';

function TimelineItemBordered(props) {
  //Note 1. the 'is' check below should be moved out of this component i.e. filtering in the parent the items which need to be rendered
  //Note 2. items with border or gradient in UI are in fact 2 data items: first is the dot / image and the second is the border / gradient, the second one
  //is set to the time range, the first one is in the middle of the time range
  //it may be possible to create only 1 item from both, code in TimelineItemGradient1.js
  //but useEffect is called randomly or with delay, so the central item ends up sometimews away from the border / gradient, not in the middle
  if (
    props.item &&
    ((props.item.showInSimple && props.isSimple) ||
      (props.item.showInComplex && !props.isSimple)) &&
    ((props.item.showInExpanded && props.isExpanded) ||
      (props.item.showInCollapsed && !props.isExpanded))
  )
    return <div className={props.item.type}></div>;
  else return null;
}

export { TimelineItemBordered };
